<template>
  <div class="home-page" :class="{ 'home-page-drawerShow': drawerShow }">
    <!-- <div class="header" v-if="!drawerShow">
      <img src="@/assets/images/logo/22.png" class="header-img" />
    </div> -->

    <b-card v-if="isShow" class="mcc-card-home">
      <b-card-title class="ft-16 line-24 fw-7 mb-10" style="color:#303133">{{
        $t('_staff.base.staffProcess')
      }}</b-card-title>
      <staff-process
        @hide="isShowStaff = false"
        @show="isShowStaff = true"
        @drawerShow="(e) => (drawerShow = e)"
      />
    </b-card>
    <b-card
      v-show="workerProcessList && workerProcessList.length"
      class="mcc-card-home"
    >
      <b-card-title class="ft-16 line-24 fw-7 mb-10" style="color:#303133">{{
        $t('_worker.base.workerProcess')
      }}</b-card-title>
      <worker-process
        @open="open"
        @close="isShow = false"
        @getWorkerProcessList="getWorkerProcessList"
        @drawerShow="(e) => (drawerShow = e)"
      />
    </b-card>
    <!-- <div class="btns">
        <div class="btns-item">
          <b-button
            variant="warning"
            class="btn-icon"
            @click="pageChange('/process/index')"
          >
            <icon-park
              icon="audit"
              fill="#FFF"
            />
          </b-button>
          <span>OA审批</span>
        </div>
      </div> -->
  </div>
</template>

<script>
import { BCard, BCardTitle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StaffProcess from '@/views/process/index.vue'
import WorkerProcess from '@/views/process/worker.vue'

export default {
  components: {
    BCard,
    StaffProcess,
    BCardTitle,
    WorkerProcess,
  },
  directives: {
    // Ripple,
  },
  data() {
    return {
      isShow: true,
      isShowStaff: true,
      workerProcessList: [],
      drawerShow: false,
    }
  },
  methods: {
    pageChange(path) {
      this.$router.push({ path })
    },
    open() {
      this.isShow = true
    },
    getWorkerProcessList(list) {
      this.workerProcessList = list
    },
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  // position: relative;
  .btns {
    display: flex;
    justify-content: flex-start;
    &-item {
      display: flex;
      flex-flow: column;
      align-items: center;
    }
  }
  .process-list-page {
    position: inherit;
  }
}
.header-img {
  margin-bottom: 16px;
  // padding:16px;
}
.header-img {
  width: 100%;
  height: auto;
  border-radius: 15px;
}
</style>
